<template>
  <nav class="navbar col p-0 mov mov2 d-block d-md-none">
    <nav class="navbar segundo d-block">
      <ul class="navbar-nav pr-0">
        <li
          class="col text-center py-5 px-4 bg-menu-azul2"
          @click="show = !show"
        >
          <div class="dropdown" :class="show ? 'show' : ''">
            <div class="text-nowrap text-uppercase p-0" id="dropdownMenu2">
              Admisión
              <br />Universitaria
            </div>
            <div class="dropdown-menu" :class="show ? 'show' : ''">
              <button @click="irInstUniver" class="dropdown-item" type="button">
                Instituciones
              </button>
              <button
                @click="irCarrerasUniver"
                class="dropdown-item"
                type="button"
              >
                Carreras
              </button>
              <!--<button class="dropdown-item" type="button">Comparador</button>-->

              <button
                @click="irAReglamento"
                class="dropdown-item"
                type="button"
              >
                Normativa
              </button>
              <button
                @click="IrACalendario"
                class="dropdown-item"
                type="button"
              >
                Calendario
              </button>
              <button
                @click="IrMaterialPreparacionU"
                class="dropdown-item"
                type="button"
              >
                Material de Preparación PAES
              </button>
            </div>
          </div>
        </li>
      </ul>
    </nav>
  </nav>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "AdmisionUniversitaria",
  data() {
    return {
      show: false
    };
  },
  methods: {
    ...mapActions(["setBusqueda", "setSimulacion"]),
    irAReglamento() {
      this.$router.push({ name: "ReglamentoU" });
    },
    IrACalendario() {
      this.$router.push({ name: "CalendarioU" });
    },
    IrAdmisionU() {
      this.$router.push({ name: "AdmisionU" });
    },
    IrMaterialPreparacionU() {
      this.$router.push({ name: "MaterialPreparacionU" });
    },
    irCarrerasUniver() {
      this.limpiarBusquedasAplicadas();
      this.$router.push({ name: "BuscadorCU" });
    },
    irInstUniver() {
      this.limpiarBusquedasAplicadas();
      this.$router.push({ name: "BuscadorInstU" });
    },
    irSimulador() {
      this.limpiarBusquedasAplicadas();
      this.limpiarDataSimulacion();
      this.$router.push({ name: "SimuladorPonderaciones" });
    },
    limpiarBusquedasAplicadas() {
      this.setBusqueda([]);
    },
    limpiarDataSimulacion() {
      this.setSimulacion({});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/generales/menuMovil/AdmisionUniversitaria.vue